'use client';

import { FaIcon } from '@micks-yard/icons/FaIcon';
import { faSpinner } from '@micks-yard/icons/solid/faSpinner';

export function PageContentLoading() {
  return (
    <div
      className="flex w-full items-center justify-center py-10"
      data-testid="page-content-loading">
      <FaIcon
        icon={faSpinner}
        className="size-9 text-green-600"
        spin
        role="status"
        aria-label="Loading"
      />
    </div>
  );
}
